{
  "difference_ballots_per_list": {
    "short_title": "Verschil tussen totalen per lijst op stembureau en gemeentelijk stembureau?",
    "title": "Is er een verschil tussen het totaal aantal getelde stembiljetten per lijst zoals eerder vastgesteld door het stembureau en zoals door u geteld op het gemeentelijk stembureau?"
  },
  "form_description": "Neem de vinkjes over zoals ze op het papieren formulier zijn gezet.",
  "form_title": "Verschillen met telresultaten van het stembureau",
  "heading_counts_of_lists": "2.3 Tellingen op lijstniveau",
  "heading_voters_and_votes": "2.1  Aantallen kiezers en stemmen",
  "short_title": "Verschillen met stembureau",
  "difference_ballots_voters_completely_accounted_for": {
    "short_title": "Zijn D en H gelijk of is het verschil volledig verklaard?",
    "title": "Is in de telresultaten van het stembureau het aantal toegelaten kiezers (D) en het totaal aantal getelde stemmen (H) gelijk OF is er een verschil en is dit verschil volledig verklaard?"
  },
  "validation_error": "Controleer of je antwoord gelijk is aan het papieren proces-verbaal"
}
